import { Reveal, Eyebrow } from "@/components/mystic/Reveal";
import { GoldButton } from "@/components/mystic/GoldButton";

const ROSE_IMG =
  "https://images.unsplash.com/photo-1618126348449-f600c78a798c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxteXN0aWNhbCUyMHJlZCUyMHJvc2UlMjBjYW5kbGUlMjBkYXJrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3OTE5MTAxNTB8MA&ixlib=rb-4.1.0&q=85";

const STEPS = [
  "Escolha um local tranquilo.",
  "Coloque a rosa diante de você.",
  "Escreva no papel três sentimentos que deseja cultivar em sua vida amorosa, como respeito, paz e carinho.",
  "Feche os olhos por alguns instantes e pense em uma relação saudável e recíproca.",
  "Guarde o papel durante três dias como símbolo de sua intenção.",
];

export function SimpatiaGratuita() {
  return (
    <section data-testid="simpatia-gratuita-section" className="relative overflow-hidden bg-carddark">
      <div className="pointer-events-none absolute right-0 top-0 h-96 w-96 rounded-full bg-borgonha/30 blur-3xl" />
      <div className="relative mx-auto max-w-5xl px-5 py-24 sm:px-8 sm:py-32">
        <Reveal className="mx-auto max-w-2xl text-center">
          <Eyebrow>Simpatia gratuita</Eyebrow>
          <h2 className="font-serif text-3xl font-semibold leading-tight text-creme sm:text-4xl lg:text-5xl">
            UM PEQUENO SEGREDO PARA
            <br />
            <span className="gold-text italic">VOCÊ EXPERIMENTAR...</span>
          </h2>
          <p className="mt-5 text-base text-creme/75 sm:text-lg">
            Conheça uma prática simbólica inspirada no universo das simpatias.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="parchment parchment-frame relative mx-auto mt-14 max-w-3xl rounded-sm p-8 text-vinho sm:p-12" data-testid="ritual-card">
            <img
              src={ROSE_IMG}
              alt="Rosa vermelha sobre o ritual"
              loading="lazy"
              className="absolute -right-6 -top-8 h-24 w-24 rotate-12 rounded-full border-2 border-dourado/70 object-cover shadow-xl sm:-right-10 sm:h-32 sm:w-32"
            />
            <p className="text-center text-[0.65rem] font-semibold uppercase tracking-[0.35em] text-borgonha">
              Ritual simbólico de demonstração
            </p>
            <h3 className="mt-3 text-center font-cinzel text-2xl text-vinho sm:text-3xl" data-testid="ritual-title">
              O RITUAL DA ROSA E DA INTENÇÃO
            </h3>
            <div className="gold-line mx-auto mt-5 w-24" />

            <div className="mt-8">
              <h4 className="font-serif text-lg font-semibold uppercase tracking-wide text-borgonha">
                Materiais
              </h4>
              <ul className="mt-3 space-y-1.5 text-sm sm:text-base">
                <li>· Uma rosa vermelha</li>
                <li>· Um pedaço de papel</li>
                <li>· Uma caneta</li>
              </ul>
            </div>

            <div className="mt-8">
              <h4 className="font-serif text-lg font-semibold uppercase tracking-wide text-borgonha">
                Passo a passo
              </h4>
              <ol className="mt-4 space-y-4">
                {STEPS.map((step, i) => (
                  <li key={i} className="flex gap-4">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-borgonha/40 font-cinzel text-sm text-borgonha">
                      {i + 1}
                    </span>
                    <span className="pt-1 text-sm leading-relaxed sm:text-base">{step}</span>
                  </li>
                ))}
              </ol>
            </div>

            <blockquote className="mt-9 border-y border-borgonha/25 py-6 text-center" data-testid="ritual-prece">
              <p className="font-serif text-lg italic leading-relaxed text-borgonha sm:text-xl">
                Que a luz ilumine meu coração.
                <br />
                Que a paz dissolva minhas mágoas.
                <br />
                Que o amor verdadeiro encontre seu caminho, se houver respeito,
                reciprocidade e liberdade.
              </p>
            </blockquote>

            <p className="mt-8 text-center font-serif text-base italic leading-relaxed sm:text-lg">
              O verdadeiro segredo não está em controlar o destino de alguém,
              mas em preparar o próprio coração para viver um amor sincero.
            </p>

            <p className="mt-6 text-center text-xs leading-relaxed text-vinho/60">
              Esta prática gratuita é apenas uma demonstração do estilo do
              conteúdo — não é uma das 50 simpatias reproduzida literalmente do livro.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.2} className="mt-14 text-center">
          <p className="font-serif text-lg uppercase tracking-[0.2em] text-dourado sm:text-xl">
            Essa é apenas uma pequena amostra do universo que você encontrará no e-book.
          </p>
          <div className="mt-8">
            <GoldButton testId="simpatia-cta-button" priceSize="sm">QUERO CONHECER AS OUTRAS 50 SIMPATIAS</GoldButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
